export default {
  id: { "ui:widget": "hidden" },
  status: {
    "ui:widget": "toggle",
  },
  notes: { "ui:widget": "textarea" },
  "ui:order": ["type", "*", "status", "notes"],
};
